export default __webpack_public_path__ + "static/media/Ntorq125FI_Frente.bfddcc77.webp";